/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
// import { DatePickerInput } from 'rc-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { ToastsStore } from 'react-toasts';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import {
  absencesNotConfirmedMsg, errMsg, noAbsenceToClear, noAbsenceToClearOrConfirm,
  noAbsenceToConfirm,
} from '../../utils/messages';
import 'rc-datepicker/lib/style.css';
import history from '../../utils/history';
import LoadingIndicator from '../../View/LoadingIndicator';
import { GET_ABSENCES_DATA, SUBMIT_ABSENCE_CLEAR } from '../../utils/apiEndPoint';
import Accordion from '../../View/Accordion';
import { usDateFormat } from '../../utils/dateFormat';

const Form = ({ setShowEarlyLeaveForm, reasons }) => {
  const [statusCode, setStatusCode] = useState(0);
  const [clearedAbsences, setClearedAbsences] = useState([]);
  const [excludedAbsences, setExcludedAbsences] = useState([]);
  const [allAbsences, setAllAbsences] = useState({});

  // error msgs
  const [reasonError, setReasonError] = useState('');
  const [allAbsencesError, setAllAbsencesError] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [clearedAbsencesError, setClearedAbsencesError] = useState('');
  const [excludedAbsencesError, setExcludedAbsencesError] = useState('');

  // loader
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  // storage
  const loggedInUser = JSON.parse(sessionStorage.getItem('login_details'));
  const token = sessionStorage.getItem('token');
  const filterData = (data) => data.map((array) => ({
    absence_date: array.absence_date,
    id: array.id,
    discrepancy_status: array.discrepancy_status,
    period: array.period,
    student_id: array.student_id,
    student_name: array.student_name,
    isActive: false,
    reason: '',
    checked: false,
  }));

  const getAbsencesData = () => {
    const userData = {
      token,
      student_id: loggedInUser.studentId,
    };
    api.post(GET_ABSENCES_DATA, userData)
      .then((response) => {
        if (response.status === 200) {
          setAllAbsences(response.data);
          setAllAbsencesError('');
          setLoading(false);
          setStatusCode(response.status);
        } else if (response.status === 302) {
          setAllAbsencesError(noAbsenceToClearOrConfirm);
          setStatusCode(response.status);
          setLoading(false);
        } else {
          setAllAbsencesError(errMsg);
          setStatusCode(404);
          setLoading(false);
        }
      }).catch((error) => {
        if (error) {
          setAllAbsencesError(errMsg);
          setStatusCode(404);
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    getAbsencesData();
  }, []);

  useEffect(() => {
    if (allAbsences && Object.keys(allAbsences).length !== 0) {
      if (allAbsences.Cleared && allAbsences.Cleared.length !== 0) {
        setClearedAbsences(filterData(allAbsences.Cleared));
      }
      if (allAbsences.Excluded && allAbsences.Excluded.length !== 0) {
        setExcludedAbsences(filterData(allAbsences.Excluded));
      }
    }
  }, [allAbsences]);

  useEffect(() => {
    const excludedError = excludedAbsences.length === 0 ? noAbsenceToConfirm : '';
    setExcludedAbsencesError(excludedError);
  }, [excludedAbsences]);

  useEffect(() => {
    const checkReason = clearedAbsences.filter((absence) => absence.reason).length;
    setButtonDisabled(checkReason <= 0);
    setClearedAbsencesError(clearedAbsences.length === 0 ? noAbsenceToClear : '');
  }, [clearedAbsences]);

  const onChangeReason = (e, id) => {
    setSubmitError('');
    setReasonError('');
    const array = clearedAbsences.map((absence) => {
      if (absence.id === id) {
        absence.reason = e.target.value;
      }
      return absence;
    });
    setClearedAbsences(array);
  };

  const handleValidation = () => {
    let formIsValid = true;
    const checkReason = clearedAbsences.filter((absence) => absence.reason).length;
    if (checkReason <= 0) {
      formIsValid = false;
      setReasonError('Please select reason for atleast one Absence Date.');
    }
    return formIsValid;
  };

  const onAccordionToggle = (id) => {
    const absenceArray = clearedAbsences.map((absence) => {
      if (absence.id === id) {
        absence.isActive = !absence.isActive;
      } else {
        absence.isActive = false;
      }
      return absence;
    });
    setClearedAbsences(absenceArray);
  };

  const onClearSelection = (id) => {
    setSubmitError('');
    const absenceArray = clearedAbsences.map((absence) => {
      if (absence.id === id) {
        absence.reason = '';
      }
      return absence;
    });
    setClearedAbsences(absenceArray);
  };

  const handleSubmitForm = (event) => {
    event.preventDefault();
    if (handleValidation()) {
      const checkReason = clearedAbsences.filter((absence) => absence.reason);
      const absenceData = checkReason.map((absence) => ({
        absence_date: absence.absence_date,
        reason: absence.reason,
        period: absence.period,
      }));
      const userAbsences = {
        token,
        student_id: loggedInUser.studentId,
        absence_data: absenceData,
      };

      setSubmitLoading(true);
      api.post(SUBMIT_ABSENCE_CLEAR, userAbsences)
        .then((response) => {
          if (response.status === 200) {
            setSubmitLoading(false);
            ToastsStore.success(response.msg);
            history.push({
              pathname: '/thankyou',
              state: {
                msg: 'Your Attendance submission has been received. The ECRCHS Attendance Team is currently processing your request.',
                btnText: 'Submit Another Request',
                path: window.location.pathname,
                logout: true,
              },
            });
          } else {
            setSubmitLoading(false);
            setSubmitError(response.msg);
          }
        }).catch((error) => {
          if (error) {
            setSubmitLoading(false);
            setSubmitError(errMsg);
          }
        });
    } else {
      // console.log('Form has errors.');
    }
  };

  const periodList = (data) => {
    const periodArray = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(data)) {
      periodArray.push(<span className={`${value} badge`}>{key}</span>);
    }
    return periodArray.map((p) => p);
  };

  const earlyLeaveButton = (
    <Link
      to="#"
      className="early_leave"
      onClick={() => setShowEarlyLeaveForm(true)}
    >
      Create Early Leave Request
      {' '}
      <FontAwesomeIcon icon={faArrowAltCircleRight} />
    </Link>
  );

  if (loading || allAbsencesError) {
    return (
      <section className="contentca ca_box profile-box">
        <div
          method="post"
          className={loading
            ? 'earlyform profile-box-top loading-data'
            : 'earlyform profile-box-top no-data-profile'}
        >
          {loading && (<LoadingIndicator />)}
          {(!loading && allAbsencesError) && (
          <>
            <p style={{
              color: statusCode === 404 ? 'red' : '#676767',
              marginTop: 10,
            }}
            >
              {allAbsencesError}
            </p>
            {earlyLeaveButton}
          </>
          )}
        </div>
      </section>
    );
  }

  return (
    <>
      <section
        className="contentca ca_box profile-box pending-absence-confirmation"
      >
        <div className="earlyform profile-early-form">
          <h2 style={{ textTransform: 'capitalize' }}>
            Pending Teacher Absence Confirmation
          </h2>
          {excludedAbsencesError ? (
            <p className="no-data-early-leave">
              {excludedAbsencesError}
            </p>
          ) : (
            <>
              <h6>{absencesNotConfirmedMsg}</h6>
              <div className="badge-note">
                <p>
                  <span className="badge Excluded" />
                  <span className="note-text">Pending Teacher Verification</span>
                </p>
                <p>
                  <span className="badge" />
                  <span className="note-text">Verified</span>
                </p>
              </div>
              <ul className="confirmation-list">
                {excludedAbsences.map((absence) => (
                  <li>
                    <span className="date-absence">
                      {usDateFormat(absence.absence_date)}
                    </span>
                    <span className="accr-period">
                      - Period :
                      {' '}
                      {periodList(absence.period)}
                    </span>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      </section>
      <section className="contentca ca_box profile-box">
        <div className="header-wrapper">
          <h2 className="header-title">
            Absence Clearance
          </h2>
          <div className="profile-box-top">
            {earlyLeaveButton}
          </div>
        </div>

        <form
          method="post"
          className="earlyform profile-early-form"
        >
          <div className={reasonError
            ? 'column reasons_position has-error-msg'
            : 'column reasons_position'}
          >
            <h2 style={{ textTransform: 'capitalize' }}>
              Pending Absence Clearance
            </h2>
            {clearedAbsencesError ? (
              <p className="no-data-early-leave">
                {clearedAbsencesError}
              </p>
            ) : (
              <>
                {clearedAbsences.map((absence) => (
                  <Accordion
                    onClick={onAccordionToggle}
                    absenceObj={absence}
                    onChange={onChangeReason}
                    onClearSelection={onClearSelection}
                    reasons={reasons}
                  />
                ))}
                {reasonError && (
                  <span style={{
                    color: 'red',
                    fontSize: 12,
                    display: 'block',
                    marginTop: 5,
                  }}
                  >
                    {reasonError}
                  </span>
                )}
                <button
                  id="submit_btn"
                  className={buttonDisabled ? 'disabled' : 'clear_absence'}
                  type="submit"
                  onClick={handleSubmitForm}
                  disabled={buttonDisabled}
                >
                  {submitLoading ? <LoadingIndicator /> : 'Submit'}
                </button>
                {submitError && (
                  <p style={{
                    color: 'red',
                    textAlign: 'center',
                    margin: '10px 0px',
                    fontSize: 12,
                  }}
                  >
                    {submitError}
                  </p>
                )}
              </>
            )}
          </div>
        </form>
      </section>
    
    </>
  );
};

export default Form;
